export default __webpack_public_path__ + "images/Iterating-kR1M5.gif";